import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { PhoneIcon } from '@ergeon/icons/hero/outline';

export const NoCallsEmptyState = () => (
  <div className="flex flex-col flex-grow justify-center items-center p-6 pb-12">
    <EmptyState
      description="Start your first call by clicking the 'New Call' button above."
      icon={<PhoneIcon />}
      title="No recent calls" />
  </div>
);
